import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactMethods = () => {
  const contactMethods = [
    {
      id: 1,
      icon: 'Phone',
      title: 'Telepon',
      description: 'Hubungi kami langsung untuk konsultasi cepat',
      value: '+62 882-9364-2972',
      link: 'tel:+6288293642972',
      color: 'bg-blue-50 text-blue-600',
      hoverColor: 'hover:bg-blue-100',
    },
    {
      id: 2,
      icon: 'MessageCircle',
      title: 'WhatsApp',
      description: 'Chat dengan tim kami untuk informasi detail',
      value: '+62 882-9364-2972',
      link: 'https://wa.me/6288293642972',
      color: 'bg-green-50 text-green-600',
      hoverColor: 'hover:bg-green-100',
      external: true,
    },
    {
      id: 3,
      icon: 'Mail',
      title: 'Email',
      description: 'Kirim pertanyaan atau permintaan informasi',
      value: 'honda.bplppm@gmail.com',
      link: 'mailto:honda.bplppm@gmail.com',
      color: 'bg-purple-50 text-purple-600',
      hoverColor: 'hover:bg-purple-100',
    },
    {
      id: 4,
      icon: 'MapPin',
      title: 'Kunjungi Showroom',
      description: 'Datang langsung ke dealer kami',
      value: 'Jl. Benda Raya, Pd. Benda, Kec. Pamulang, Kota Tangerang Selatan, Banten 15416',
      link: '#location',
      color: 'bg-red-50 text-red-600',
      hoverColor: 'hover:bg-red-100',
    },
  ];

  const handleClick = (e, link) => {
    if (link === '#location') {
      e?.preventDefault();
      const locationSection = document.getElementById('location');
      if (locationSection) {
        locationSection?.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12 lg:mb-16" data-aos="fade-up" data-aos-delay="150">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-3 md:mb-4">
            Cara Menghubungi Kami
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Pilih metode komunikasi yang paling nyaman untuk Anda
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8" data-aos="zoom-in" data-aos-delay="150">
          {contactMethods?.map((method) => (
            <a
              key={method?.id}
              href={method?.link}
              target={method?.external ? '_blank' : undefined}
              rel={method?.external ? 'noopener noreferrer' : undefined}
              onClick={(e) => handleClick(e, method?.link)}
              className={`group bg-card rounded-xl p-6 md:p-8 transition-all duration-300 hover:shadow-card-hover border border-border ${method?.hoverColor}`}
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 rounded-xl ${method?.color} flex items-center justify-center mb-4 md:mb-6 group-hover:scale-110 transition-transform duration-300`} >
                <Icon name={method?.icon} size={28} className="w-6 h-6 md:w-7 md:h-7" />
              </div>

              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground mb-2 md:mb-3">
                {method?.title}
              </h3>

              <p className="text-xs md:text-sm text-muted-foreground mb-3 md:mb-4 leading-relaxed">
                {method?.description}
              </p>

              <p className="text-sm md:text-base font-semibold text-primary group-hover:text-accent transition-colors">
                {method?.value}
              </p>

              <div className="mt-4 md:mt-6 flex items-center text-primary group-hover:text-accent transition-colors">
                <span className="text-xs md:text-sm font-medium">Hubungi Sekarang</span>
                <Icon name="ArrowRight" size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;